import { render, staticRenderFns } from "./DashInventoryList.vue?vue&type=template&id=012099c3&scoped=true&"
import script from "./DashInventoryList.vue?vue&type=script&lang=js&"
export * from "./DashInventoryList.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryList.vue?vue&type=style&index=0&id=012099c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012099c3",
  null
  
)

export default component.exports